import catalogos from './catalogos/catalogos'
import sistema from "./Sistema/sistemaREGOP";

const regop = {
  catalogos: catalogos,
  sistema: sistema  
}
export default regop


//////////////////
// WEBPACK FOOTER
// ./static/js/api/REGOP/REGOPapi.js
// module id = null
// module chunks = 